import { useRef, useEffect } from 'react';
import { useMediaQuery } from '../../components/MediaQueryProvider/MediaQueryProvider.mjs';

const DEFAULT_OPTIONS = {
  axis: 'vertical',
  disabled: false,
  maxScrollDistance: 100
};
function useScrollHint(element, options) {
  const {
    axis,
    disabled,
    maxScrollDistance
  } = {
    ...DEFAULT_OPTIONS,
    ...options
  };
  const hasPerformedScrollHint = useRef(false);
  const {
    prefersReducedMotion
  } = useMediaQuery();
  useEffect(() => {
    if (disabled || element == null || prefersReducedMotion || hasPerformedScrollHint.current) {
      return;
    }
    const {
      clientWidth,
      clientHeight,
      scrollWidth,
      scrollHeight
    } = element;
    const isVertical = axis === 'vertical';
    const scrollableSize = isVertical ? scrollHeight : scrollWidth;
    const clientSize = isVertical ? clientHeight : clientWidth;
    const canScroll = scrollableSize > clientSize;
    if (canScroll) {
      const scrollDistance = Math.min(maxScrollDistance, scrollableSize - clientSize);
      hasPerformedScrollHint.current = true;
      const position = isVertical ? 'top' : 'left';
      element.scrollTo({
        [position]: scrollDistance
      });
      requestAnimationFrame(() => {
        element.scrollTo({
          [position]: 0,
          behavior: 'smooth'
        });
      });
    }
  }, [axis, disabled, element, maxScrollDistance, prefersReducedMotion]);
}

export { useScrollHint };
